import React  from 'react';
import MainLayout from './mainLayout';
import {
    Row,
    Col,
    Icon
} from 'antd';
import {Link} from "react-router-dom";

export default class PriceListLayout extends React.Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <MainLayout>
                <div className={"faqWrapper"}>
                    <div className="container">
                        <div className="faq">
                            <Row gutter={18} type={'flex'} justify={'center'} align={'top'}>
                                <Col xs={22} sm={20} md={20} lg={15} xl={15}>
                                    <div>
                                        {this.props.children}
                                    </div>
                                </Col>

                                <Col xs={22} sm={20} md={20} lg={9} xl={9}>
                                    <div className="priceListVintages priceListTopVintage">
                                        <img src={"/clientAssets/mainVintage.png"} />
                                    </div>
                                    <div className={"priceListRightSec1"}>
                                        <div className="priceListRightItem">
                                            <Link to={"/price-list/exchange-rate"}>
                                                <div>
                                                    <Icon type="dollar" />
                                                </div>
                                                <p>نرخ ارز</p>
                                            </Link>
                                        </div>

                                        <div className="priceListRightItem">
                                            <Link to={"/price-list/coin-rate"}>
                                                <div>
                                                    <Icon type="gold" />
                                                </div>
                                                <p>نرخ سکه</p>
                                            </Link>
                                        </div>

                                        <div className="priceListRightItem">
                                            <Link to={"/price-list/transfer-rate"}>
                                                <div>
                                                    <Icon type="file-protect" />
                                                </div>
                                                <p>نرخ حواله</p>
                                            </Link>
                                        </div>

                                        <div className="priceListRightItem">
                                            <Link to={"/price-list/change-rate"}>
                                                <div>
                                                    <Icon type="retweet" />
                                                </div>
                                                <p>نرخ برابری ارز</p>
                                            </Link>
                                        </div>

                                        <div className="priceListRightItem">
                                            <Link to={"/price-list/bank-rate"}>
                                                <div>
                                                    <Icon type="profile" />
                                                </div>
                                                <p>نرخ بانک مرکزی</p>
                                            </Link>
                                        </div>

                                        <div className="priceListRightItem">
                                            <Link to={"/price-list/cryptocurrency-rate"}>
                                                <div>
                                                    <Icon type="global" />
                                                </div>
                                                <p>نرخ ارزهای دیجیتال</p>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="priceListVintages priceListBottomVintage">
                                        <img src={"/clientAssets/mainVintage.png"} />
                                    </div>
                                </Col>
                            </Row>      
                        </div>
                    </div>
                </div>
            </MainLayout>
        )
    }
}